
import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { PatientTemplateClinicalStatusNoteModalStore } from '../stores';
import { PatientTemplateClinicalStatusNoteModalTemplate } from 'themes/application/niko-patient/components';

@setCurrentView((rootStore, componentProps) => new PatientTemplateClinicalStatusNoteModalStore(rootStore, componentProps), 'patientTemplateClinicalStatusNoteModalStore')
@observer
class PatientTemplateClinicalStatusNoteModal extends React.Component {
    render() {
        return <PatientTemplateClinicalStatusNoteModalTemplate {...this.props} />
    }
}

export default PatientTemplateClinicalStatusNoteModal;
